/**
 * Codemade OÜ
 *
 * Root getters for RewardDeals application
 *
 * @summary Root getters for RewardDeals application
 * @author Borka Martin Orlov
 *
 * @description https://vuex.vuejs.org/guide/getters.html
 *
 * Created at     : 2020-08-22 19:54:33
 * Last modified  : 2020-11-18 17:12:21
 */

export default {
    /**
     * @function isAuthenticated
     * @returns {Boolean}
     * If the user is authenticated
     * */
    isAuthenticated: (state) => !!state.user.token,

    /**
     * @function userPoints
     * @returns {Integer}
     * How many points does the user have
     * */
    userPoints: state => {
        if ('points' in state.user.profile) {
            return state.user.profile.points;
        } 
        
        return 0;
    },

    userPaymentThreshold: state => {
        if ('minimal_payment_threshold' in state.user.profile) {
            return state.user.profile.minimal_payment_threshold;
        } 
        
        return 0;
    },

    userPaymentPending: state => {
        if ('daily_prizes_pending' in state.user.profile) {
            return state.user.profile.daily_prizes_pending;
        } 
        
        return 0;
    },


    /**
     * @function userPoints
     * @returns {Integer}
     * How many points does the user have
     * */
    avatar: (state) => {
        if ('avatar' in state.user.profile) {
            return state.user.profile.avatar;
        } 

        return '/images/assets/default_profile.png';
    },

    status: (state) => {
        if ('status' in state.user.profile) {
            return state.user.profile.status;
        } 
        
        return 1;
    },


    name: (state) => {
        if ('name' in state.user.profile) {
            return state.user.profile.name;
        } 
        
        return 'Name';
    },

    user_id: (state) => {
        if ('id' in state.user.account) {
            return state.user.account.id;
        } 

        return '';
    },

    is_moderator: (state) => {
        if ('is_moderator' in state.user.profile) {
            return state.user.profile.is_moderator;
        } 
        
        return false;
    },

    is_admin: (state) => {
        if ('is_admin' in state.user.profile) {
            return state.user.profile.is_admin;
        } 
        
        return false;
    },
}
